import { doc, onSnapshot, getDoc } from "firebase/firestore";
import { db } from "./firebase";

// realtime (CMS-like)
export function listenCmsContent(cb, onError) {
  const ref = doc(db, "cms", "content_ar");
  return onSnapshot(
    ref,
    (snap) => cb(snap.exists() ? snap.data() : null),
    (err) => onError?.(err)
  );
}

// one-time fetch
export async function getCmsContentOnce() {
  const ref = doc(db, "cms", "content_ar");
  const snap = await getDoc(ref);
  return snap.exists() ? snap.data() : null;
}

